<template>
    <div id="letter">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/invitemanage/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>中标通知书/感谢信</span></h2>
                    <!--<p>发布时间：{{ endTime }}</p>-->
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container">
                <h2>
                    <img src="../../../assets/images/invitemanage/tit08.png"/>
                </h2>
                <el-table
                    :data="noticesData"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        prop="segmentsName"
                        label="标段"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="中标通知书">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row)" title="点击下载">
                                {{ scope.row.attachName}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="sendTime"
                        label="发出日期">
                    </el-table-column>
                    <el-table-column
                        prop="downloadTime"
                        label="下载时间">
                    </el-table-column>
                </el-table>
            </section>
            <section class="small-container">
                <h2 class="thanks">
                    <img src="../../../assets/images/invitemanage/tit07.png"/>
                </h2>
                <el-table
                    :data="thanksData"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        prop="segmentsName"
                        label="标段"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="感谢信">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row)" title="点击下载">
                                {{ scope.row.attachName}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="sendTime"
                        label="发出日期">
                    </el-table-column>
                    <el-table-column
                        prop="downloadTime"
                        label="查看时间">
                    </el-table-column>
                </el-table>
            </section>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../MasterHeader.vue';
    export default {
        name: 'letter',
        data() {
            return {
                projectName: '',//项目名称
                endTime: '',
                noticesData: [],//中标通知书
                thanksData: []//感谢信
            }
        },
        components: {MyHeader},
        created(){
            this.$root.activeIndex = 'win';
            this.getData();//初始化数据
        },
        methods: {
            getData(){
                let that = this;
                this.$root.getHttp('/v1/outerformflow/noticeAndThanks/list?formId='+this.$route.params.formId,function (res) {
//                console.log(res)
                    that.noticesData = res.data.data.notices;
                    that.thanksData = res.data.data.thanks;
                    that.getSegmentsName(that.noticesData);
                    that.getSegmentsName(that.thanksData);
                    that.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
                    that.endTime = res.data.data.dealBisVo.flowFormExtMng.createDate;
                })
            },
            getSegmentsName(arr){
                if(!arr.length){
                    return;
                }
                arr.forEach( (item,i) => {
                    if(item.segmentsNumber == 1){
                        item.segmentsName = '标段一';
                    } else if(item.segmentsNumber == 2){
                        item.segmentsName = '标段二';
                    } else if(item.segmentsNumber == 3){
                        item.segmentsName = '标段三';
                    }
                })
            },
            fileListHandleDownload(val) {
//                console.log(val, '下载')
                 let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    that.$root.postHttp('/v1/outerformflow/bidFile/down',{
                        formId: val.flowFormId,
                        relatedId: val.id,
                        type: val.attachType
                    },function (res) {
                        //code 1 成功了再进行下载
                        that.$root.downloadFile({
                            attachName: val.attachName,
                            attachPath: val.attachUrl
                        });
                        that.getData();
                    });
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#letter {
    padding-bottom: 50px;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        margin-top: 80px;
        img {
            width: 100%;
            height: 140px;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
    }
    .small-container {
        margin: 30px auto 0;
        padding: 30px 80px 60px;
        background: #fff;
        .thanks img {
            width: 200px;
        }
        h2 {
            margin-top: 20px;
            overflow: hidden;
            text-align: left;
            img {
                float: left;
                width: 300px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 6px 10px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 3px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/backStandard/icon01.png') no-repeat;
                }
            }
        }
        .el-table{
            margin-top: 20px;
            th {
              text-align: center;
            }
            & .words {
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
        .el-pagination{
            margin: 60px 0 30px;
            text-align: right;
            .el-pagination__total {
                float: left;
            }
            .btn-prev,
            .btn-next {
                padding: 0 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/Letter.vue